<div class="p-3">
  <h3>
    {{
      isViewPage()
        ? ('taxResult.taxResultView.title' | translate)
        : ('editTaxResultList.title' | translate)
    }}
  </h3>
  <div class="mt-3">
    <div class="d-flex gap-3 mb-4 justify-content-end">
      <ap-button
        [btnType]="isViewPage() ? 'primary' : 'secondary'"
        [label]="
          isViewPage()
            ? ('taxResult.taxResultView.backButton' | translate)
            : ('shared.cancel' | translate)
        "
        (onClick)="cancel()" />
      @if (!isViewPage()) {
        <ap-button
          btnType="text"
          icon="save-outline"
          [disabled]="
            !hasChanges() || (!hasCommentChanges() && hasDuplicatedValue())
          "
          [label]="'shared.save' | translate"
          (onClick)="saveHandler()" />
      }
      @if (!isViewPage()) {
        <ap-button
          btnType="primary"
          [disabled]="
            securities().length === 0 || hasErrors() || hasUnsureValue()
          "
          [label]="'shared.approve' | translate"
          (onClick)="approve()" />
      }
    </div>
    <gstar-accordion class="w-100" [multiple]="false">
      @for (
        securityReview of securities();
        track securityReview.security.securityId;
        let index = $index
      ) {
        <gstar-tax-result-card
          [isReadonly]="isViewPage()"
          [securityReview]="securityReview"
          class="d-flex justify-content-between"
          (removeFromSelection)="removeFromSelectionHandler($event)"
          (delete)="deleteHandler($event)" />
      }
    </gstar-accordion>
  </div>
</div>
